export const DAY_OF_WEEK_LABELS = {
  0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六'
}

const MINUTES_IN_DAY = 24 * 60

/**
 * Convert an "HH:MM" string to minutes-from-midnight.
 * @param {string} timeStr
 * @returns {number}
 */
export function timeToMinutes(timeStr) {
  if (!timeStr) return 0
  const [h, m] = timeStr.split(':').map(Number)
  return h * 60 + m
}

/**
 * Expand a time range into day-bounded segments, splitting a cross-midnight
 * range (end <= start, e.g. 22:00–02:00) into "start→24:00 on this day" and
 * "00:00→end on the next day column". end === start is invalid and yields no
 * segment. This is the single source of the frontend cross-midnight split.
 *
 * @param {number} dayIndex - 0=Sunday .. 6=Saturday
 * @param {number} start - minutes-from-midnight
 * @param {number} end - minutes-from-midnight
 * @returns {Array<{day: number, from: number, to: number}>}
 */
export function rangeSegments(dayIndex, start, end) {
  if (end > start) return [{ day: dayIndex, from: start, to: end }]
  if (end === start) return []
  return [
    { day: dayIndex, from: start, to: MINUTES_IN_DAY },
    { day: (dayIndex + 1) % 7, from: 0, to: end }
  ]
}

/**
 * Format a schedule_rule object into a human-readable string.
 *
 * @param {Object} scheduleRule - { day_of_week, start_time, end_time }
 * @param {Object} [options]
 * @param {string} [options.prefix] - Prefix before day label (e.g., "每週" or "Every ")
 * @returns {string|null}
 */
export function formatSchedulePattern(scheduleRule, { prefix = '每週' } = {}) {
  if (!scheduleRule) return null
  const { day_of_week, start_time, end_time } = scheduleRule
  const dayLabel = DAY_OF_WEEK_LABELS[day_of_week] ?? day_of_week
  const timeRange = end_time ? `${start_time}–${end_time}` : start_time
  return `${prefix}${dayLabel} ${timeRange}`
}
